(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["droplit-conversion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-pet-upload]');
  if (!trigger) return;
  const input = document.querySelector('.dl input[data-upload]');
  if (!input || input.disabled) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  try {
    if (typeof input.showPicker === 'function') input.showPicker();
    else input.click();
  } catch (error) { input.click(); }
  window.DroplitFunnel?.track?.('pet_upload_cta_clicked', { source: 'pets' });
}, true);
document.addEventListener('change', event => {
  if (!document.querySelector('[data-landing-skin="pets"]') || !event.target.matches('.dl input[data-upload]') || !event.target.files?.length) return;
  document.getElementById('make')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droplit-inspiration"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('customer-hats-carousel')) {
  customElements.define('customer-hats-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.dl-customer-hats__track');
      const buttons = this.querySelectorAll('[data-direction]');
      const update = () => buttons.forEach(button => {
        button.disabled = Number(button.dataset.direction) < 0
          ? track.scrollLeft <= 2
          : track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      });
      buttons.forEach(button => button.addEventListener('click', () => {
        const slide = track.querySelector('figure');
        const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({ left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }));
      track.addEventListener('scroll', update, { passive: true });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); this.initialized = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droplit-library-qa"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('droplit-library-browser')){
class DropLitLibraryBrowser extends HTMLElement{
 connectedCallback(){if(this.started)return;this.started=true;this.items=[];this.limit=24;this.$=s=>this.querySelector(s);this.$('[data-search]').oninput=()=>this.resetPage();for(const s of ['category','collection','sort'])this.$('[data-'+s+']').onchange=()=>this.resetPage();this.$('[data-more]').onclick=()=>{this.limit+=24;this.render();};this.$('[data-reset]').onclick=()=>{for(const s of ['search','category','collection'])this.$('[data-'+s+']').value='';this.resetPage();};this.$('[data-retry]').onclick=()=>this.load();this.$('[data-use]').onclick=()=>this.useDesign();this.$('[data-close]').onclick=()=>this.$('dialog').close();this.load();}
 disconnectedCallback(){this.abort?.abort();this.started=false;}
 async load(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;this.$('[data-retry]').hidden=true;this.$('[data-status]').textContent=this.dataset.loading;try{const endpoint=new URL(this.dataset.endpoint);if(endpoint.protocol!=='https:')throw Error();let next='',items=[],pages=0;do{const url=new URL(endpoint);if(next)url.searchParams.set('after',next);const response=await fetch(url,{signal,credentials:'omit'});if(!response.ok)throw Error();const data=await response.json();if(!Array.isArray(data.designs))throw Error();items.push(...data.designs);next=data.next;if(++pages>100)throw Error();}while(next);if(signal.aborted)return;this.items=items;for(const [field,selector] of [['categories','category'],['collections','collection']]){const select=this.$('[data-'+selector+']');while(select.options.length>1)select.remove(1);const values=[...new Set(items.flatMap(x=>x[field]||[]))].sort((a,b)=>a.localeCompare(b));for(const value of values)select.add(new Option(value,value));}this.resetPage();}catch(e){if(signal.aborted)return;this.items=[];this.$('[data-grid]').replaceChildren();this.$('[data-more]').hidden=true;this.$('[data-status]').textContent=this.dataset.unavailable;this.$('[data-retry]').hidden=false;}}
 async useDesign(){
 const d=this.chosen,root=document.querySelector('.dl'),slot=Number(this.$('[data-target]').value),message=this.$('[data-selection-status]'),button=this.$('[data-use]');
 if(!root?.__dlAssign||!root.__dlSlots){message.textContent=this.dataset.unready;return;}
 const unlocked=slot===0||(root.dataset.dlSaved1==='1'&&(slot===1||root.dataset.dlSaved2==='1'));
 if(!unlocked){message.textContent=this.dataset.locked;return;}
 button.disabled=true;message.textContent=this.dataset.selecting;let url;
 try{
  const asset=new URL(d.artwork_url),endpoint=new URL(this.dataset.endpoint);
  if(asset.origin!==endpoint.origin||asset.protocol!=='https:'||!asset.pathname.startsWith('/api/library/artwork/')||!Number.isFinite(d.width*d.height)||d.width*d.height>30000000)throw Error();
  const response=await fetch(asset,{credentials:'omit',signal:AbortSignal.timeout(30000)});if(!response.ok)throw Error();
  const blob=await response.blob();if(blob.size>25*1024*1024||!['image/png','image/jpeg','image/webp'].includes(blob.type))throw Error();
  const bitmap=await createImageBitmap(blob);const valid=bitmap.width===d.width&&bitmap.height===d.height;bitmap.close();if(!valid)throw Error();
  if(!this.isConnected||!this.$('dialog').open||this.chosen!==d)return;
  const extension=blob.type==='image/png'?'png':blob.type==='image/jpeg'?'jpg':'webp';const file=new File([blob],d.id+'.'+extension,{type:blob.type});url=URL.createObjectURL(file);
  delete root.dataset['dlSaved'+(slot+1)];root.__dlSetActive?.(slot);
  root.__dlAssign({preview:url,originalPreview:url,production:d.artwork_url,file,originalFile:file,title:d.title,source:'library',libraryProductId:d.id,libraryDesignId:d.id,libraryArtworkVersion:d.artwork_version,libraryOriginalUrl:d.artwork_url,libraryCategory:(d.categories||[]).join(', ')},slot);
  this.$('dialog').close();this.$('[data-status]').textContent=this.dataset.ready;root.scrollIntoView({behavior:'smooth',block:'start'});
 }catch(e){if(url)URL.revokeObjectURL(url);message.textContent=this.dataset.selectionError;}finally{button.disabled=false;}
 }

 resetPage(){this.limit=24;this.render();}
 render(){const q=this.$('[data-search]').value.trim().toLowerCase(),category=this.$('[data-category]').value,collection=this.$('[data-collection]').value;const list=this.items.filter(d=>(!category||(d.categories||[]).includes(category))&&(!collection||(d.collections||[]).includes(collection))&&(!q||[d.title,d.artist,...(d.categories||[]),...(d.tags||[])].join(' ').toLowerCase().includes(q)));const featured=this.$('[data-sort]').value==='featured';list.sort((a,b)=>(featured?Number(!!b.featured)-Number(!!a.featured):0)||a.title.localeCompare(b.title));this.$('[data-status]').textContent=list.length?list.length+' '+this.dataset.count:this.dataset.empty;this.$('[data-more]').hidden=list.length<=this.limit;const grid=this.$('[data-grid]');grid.replaceChildren();for(const d of list.slice(0,this.limit)){const card=document.createElement('button');card.type='button';card.setAttribute('aria-label',this.dataset.preview+': '+d.title);const img=document.createElement('img');img.width=240;img.height=180;img.loading='lazy';img.decoding='async';img.alt=d.title;try{const u=new URL(d.preview_url);if(u.protocol==='https:')img.src=u.href;}catch{}img.onerror=()=>{img.removeAttribute('src');img.alt=this.dataset.artwork;card.disabled=true;};const name=document.createElement('strong');name.textContent=d.title;const cat=document.createElement('small');cat.textContent=(d.categories||[]).join(' · ');card.append(img,name,cat);card.onclick=()=>{this.$('[data-title]').textContent=d.title;this.$('[data-large]').src=img.src;this.$('[data-large]').alt=d.title;this.$('[data-detail]').textContent=(d.collections||[]).join(' · ');this.chosen=d;this.$('[data-selection-status]').textContent='';const root=document.querySelector('.dl');this.$('[data-target]').value=String(root?.__dlGetActive?.()||0);this.$('dialog').showModal();};grid.append(card);}}
}
customElements.define('droplit-library-browser',DropLitLibraryBrowser);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droplit-mike"] && !Shopify.designMode) return;
  try {
    

(() => {
  function initMike() {
    const page = document.querySelector('[data-mike-page]');
    const root = document.querySelector('.dl');
    if (!page || !root || page.dataset.ready) return;
    page.dataset.ready = '1';
    root.classList.add('mike-builder');
    const words = JSON.parse(page.querySelector('[data-mike-strings]').textContent);
    const dialog = page.querySelector('.mike-dialog');
    const feedback = page.querySelector('[data-mike-status]');
    const options = page.querySelector('[data-mike-options]');
    const category = 'Mike Drops (DropLit x Mike McIntire Art)';
    const origin = 'https://droplit-nfc.brian-1b8.workers.dev';
    const grid = page.querySelector('.mike-art-grid');
    const empty = page.querySelector('[data-mike-empty]');
    let requestId = 0;
    const libraryFilters=page.querySelector('.mike-library-filters');
    const normalizeFilter=value=>String(value).toLowerCase().replace(/[^a-z0-9]/g,'');
    const catalogCache=new Map();
    async function loadArt(mikeOnly = true, filter = 'all') {
      const currentRequest = ++requestId;
      libraryFilters.hidden=mikeOnly;
      libraryFilters.querySelectorAll('[data-library-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.libraryFilter===filter)));
      grid.replaceChildren();
      empty.hidden = false;
      empty.textContent = words.loading;
      try {
        const designs = [...(catalogCache.get(mikeOnly)||[])];
        let after = '';
        const cursors = new Set();
        if(!catalogCache.has(mikeOnly))do {
          const url = new URL('/api/library/catalog', origin);
          if (mikeOnly) url.searchParams.set('category', category);
          if (after) url.searchParams.set('after', after);
          const response = await fetch(url, {signal:AbortSignal.timeout(15000)});
          if (!response.ok) throw new Error('catalog');
          const data = await response.json();
          if (!Array.isArray(data.designs)) throw new Error('catalog');
          designs.push(...data.designs);
          after = data.next || '';
          if (after && cursors.has(after)) throw new Error('pagination');
          cursors.add(after);
        } while (after);
        catalogCache.set(mikeOnly,designs);
        if (currentRequest !== requestId) return;
        let usable = designs.filter(d => (!mikeOnly || d.categories?.includes(category)) && d.artwork_version && d.artwork_url?.startsWith(origin + '/api/library/artwork/') && d.preview_url?.startsWith(origin + '/api/library/preview/'));
        if(!mikeOnly&&filter!=='all'&&filter!=='random')usable=usable.filter(d=>filter==='kreteswell'?d.categories?.includes(category):[...(d.categories||[]),...(d.tags||[]),...(d.collections||[])].some(value=>filter==='memes'?['memes','funny','funnymemes'].includes(normalizeFilter(value)):normalizeFilter(value)===normalizeFilter(filter)));
        if(filter==='random'){usable=[...usable];for(let i=usable.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[usable[i],usable[j]]=[usable[j],usable[i]];}}
        if (mikeOnly && usable.length) {
          const heroDesign = usable.find(design => design.id === 'recovered-mike-d305e88ac0d521be1b05') || usable.find(design => /headphones.*buy art not algorithms/i.test(design.title)) || usable[0];
          const hero = page.querySelector('[data-mike-hero-art]'); if(hero){hero.src=heroDesign.preview_url; hero.alt=heroDesign.title; hero.hidden=false;}
          const inline=page.querySelector('[data-mike-gallery]'); if(inline) inline.replaceChildren();
          usable.forEach(design=>{const b=document.createElement('button');b.type='button';b.className='mike-art';b.dataset.mikeDesignId=design.id;b.setAttribute('aria-pressed',String(root.__dlSlots?.[0]?.mikeDesignId===design.id));const im=document.createElement('img');im.src=design.preview_url;im.alt='';im.width=300;im.height=300;im.loading='lazy';const label=document.createElement('strong');label.textContent=design.title;b.append(im,label);b.addEventListener('click',()=>choose(design,0));inline?.append(b)});
        }
        for (const design of usable) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mike-art';
          const image = document.createElement('img');
          image.src = design.preview_url;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 400;
          image.height = 400;
          const label = document.createElement('strong');
          label.textContent = design.title;
          button.append(image, label);
          button.addEventListener('click', () => {
            choose(design,target);
          });
          grid.append(button);
        }
        empty.hidden = usable.length > 0;
        empty.textContent = words.empty;
      } catch (error) {
        if (currentRequest !== requestId) return;
        empty.hidden = false;
        empty.textContent = words.loadError;
      }
    }
    function choose(design,index) {
      if (!root.__dlAssign || root.dataset.dlUploadBusy==='1' || root.dataset.dlBgBusy==='1') return;
      const isMike=design.categories.includes(category);
      root.__dlAssign({preview:isMike?design.preview_url:design.artwork_url,originalPreview:design.artwork_url,production:design.artwork_url,title:design.title,source:isMike?'mike-mcintire':'library',artworkLocked:isMike,mikeDesignId:isMike?design.id:null,libraryDesignId:design.id,libraryArtworkVersion:design.artwork_version,libraryRevision:design.revision,previewSize:design.preview_size||'medium',scale:1,positionX:0,positionY:0},index);
      if(dialog.open)close();say(isMike?words.locked:words.ready);sync();
      root.querySelector('.stageviewport').scrollIntoView({block:'center',behavior:'smooth'});
    }
    libraryFilters.querySelectorAll('[data-library-filter]').forEach(button=>button.addEventListener('click',()=>loadArt(false,button.dataset.libraryFilter)));
    libraryFilters.querySelectorAll('[data-filter-scroll]').forEach(button=>button.addEventListener('click',()=>{const track=libraryFilters.querySelector('[data-filter-track]');track.scrollBy({left:Number(button.dataset.filterScroll)*track.clientWidth*.75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
    let target = 0;
    let opener;
    const say = message => { if(feedback) feedback.textContent = message; };
    const close = () => { dialog.close(); opener?.focus(); };
    function open(index, button) {
      if (root.dataset.dlUploadBusy === '1' || root.dataset.dlBgBusy === '1') return;
      if (!root.__dlSetActive) return say(words.loading);
      target = index;
      opener = button;
      root.__dlSetActive(index);
      options.hidden = index === 0;
      page.querySelector('#mike-dialog-title').textContent = index === 0 ? words.firstTitle : words.secondTitle;
      dialog.showModal();
      loadArt(true);
    }
    page.querySelectorAll('[data-mike-open]').forEach(button => button.addEventListener('click', () => open(Number(button.dataset.mikeOpen), button)));
    page.querySelector('[data-mike-close]').addEventListener('click', close);
    dialog.addEventListener('cancel', () => { opener?.focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog && (event.clientX < dialog.getBoundingClientRect().left || event.clientX > dialog.getBoundingClientRect().right || event.clientY < dialog.getBoundingClientRect().top || event.clientY > dialog.getBoundingClientRect().bottom)) close(); });
    window.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const tile = event.target.closest('[data-slot]');
      if (tile && root.contains(tile) && !event.target.closest('.dl-drop-delete')) {
        if (tile.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        open(Number(tile.dataset.slot) - 1, tile);
      }
      const add = event.target.closest('[data-add]');
      if (add && root.contains(add) && !root.__dlSlots?.[0]?.mikeDesignId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        say(words.chooseFirst);
        page.querySelector('[data-mike-open="0"]')?.scrollIntoView({block:'center'});
      }
    }, true);
    page.querySelector('[data-mike-upload]').addEventListener('click', () => {
      if (target === 0) return;
      close();
      root.__dlSetActive(target);
      root.querySelector('[data-upload]').click();
    });
    page.querySelector('[data-mike-library]').addEventListener('click', () => {
      if (target === 0) return;
      page.querySelector('#mike-dialog-title').textContent = words.libraryTitle;
      loadArt(false);
    });
    function alignLibraryPreview(){
      const active=root.__dlSlots?.[root.__dlGetActive?.()||0];
      const drop=root.querySelector('.drop'),hat=root.querySelector('.stage .hat'),stage=root.querySelector('[data-stage]');
      if(!drop||!hat||!stage)return;
      if(!active?.libraryDesignId){if(drop.dataset.mikeAligned){for(const key of ['left','top','width','height','transform','scale'])drop.style.removeProperty(key);delete drop.dataset.mikeAligned;}return;}
      if(!hat.naturalWidth||!hat.naturalHeight)return;
      const ratio=Math.min(stage.clientWidth/hat.naturalWidth,stage.clientHeight/hat.naturalHeight);
      const w=hat.naturalWidth*ratio,h=hat.naturalHeight*ratio;
      const size=Math.min(w,h)*.3588*({small:.85,medium:1,large:1.15,xl:1.3225,xxl:1.520875,xxxl:1.74900625}[active.previewSize]||1);
      drop.dataset.mikeAligned='1';
      drop.style.setProperty('left',((stage.clientWidth-w)/2+w*.505)+'px','important');
      drop.style.setProperty('top',((stage.clientHeight-h)/2+h*.445)+'px','important');
      drop.style.setProperty('width',size+'px','important');
      drop.style.setProperty('height',size+'px','important');
      drop.style.setProperty('transform','translate(-50%,-50%)','important');
      drop.style.setProperty('scale','1','important');
    }
    const previewHat=root.querySelector('.stage .hat');
    previewHat?.addEventListener('load',alignLibraryPreview);
    if('ResizeObserver' in window)new ResizeObserver(alignLibraryPreview).observe(root.querySelector('[data-stage]'));
    function sync(){
      alignLibraryPreview();
      const rights=root.querySelector('[data-rights]')?.closest('.rights');if(rights)rights.hidden=!(root.__dlSlots||[]).some(d=>d&&!d.libraryDesignId&&!d.mikeDesignId);
      const active=root.__dlSlots?.[root.__dlGetActive?.()||0];root.classList.toggle('mike-art-locked',!!active?.mikeDesignId);
      page.querySelectorAll('[data-mike-picked]').forEach(im=>{const d=root.__dlSlots?.[Number(im.dataset.mikePicked)];im.hidden=!d;if(d){im.src=d.preview;im.alt=d.title;im.closest('button').querySelector('strong').textContent=d.title;}});
      page.querySelectorAll('[data-mike-gallery] [data-mike-design-id]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.mikeDesignId===root.__dlSlots?.[0]?.mikeDesignId)));
      const price=root.querySelector('[data-total]')?.textContent;if(price)page.querySelectorAll('[data-mike-price],[data-mike-sticky-price]').forEach(el=>el.textContent=price);
    }
    const locked=()=>!!root.__dlSlots?.[root.__dlGetActive?.()||0]?.mikeDesignId;
    for(const type of ['click','input','change','pointerdown'])window.addEventListener(type,event=>{
      if(!(event.target instanceof Element)||!root.contains(event.target)||!locked())return;
      if(event.target.closest('[data-mobile-crop],[data-mobile-bg],[data-mobile-size],[data-crop],[data-bgremove],[data-scale],[data-move-x],[data-move-y],[data-move-center],.dl-rotate,.dl-rotation')){event.preventDefault();event.stopImmediatePropagation();say(words.locked);}
    },true);
    root.addEventListener('droplit:drop-saved', event=>{
      requestAnimationFrame(()=>{
        if(event.detail?.slot===1&&!root.__dlSlots?.[1])root.__dlSetActive(1);
        sync();
      });
    });
    root.addEventListener('droplit:state-changed',()=>requestAnimationFrame(sync));
    const previewImage=root.querySelector('[data-preview]');
    if(previewImage)new MutationObserver(()=>requestAnimationFrame(sync)).observe(previewImage,{attributes:true,attributeFilter:['src','hidden']});
    root.addEventListener('click',()=>requestAnimationFrame(sync));root.addEventListener('change',()=>requestAnimationFrame(sync));
    window.addEventListener('droplit:image-selected',()=>requestAnimationFrame(sync));
    const sticky=page.querySelector('.mike-sticky');
    if ('IntersectionObserver' in window) {
      let heroVisible=true, builderVisible=false;
      const refreshSticky=()=>{sticky.hidden=heroVisible||builderVisible;};
      new IntersectionObserver(entries=>{heroVisible=entries[0].isIntersecting;refreshSticky();},{threshold:0}).observe(page.querySelector('.mike-hero') || page);
      new IntersectionObserver(entries=>{builderVisible=entries[0].isIntersecting;refreshSticky();},{threshold:0}).observe(root);
    }
    page.querySelector('[data-mike-continue]').addEventListener('click',()=>{const slots=root.__dlSlots||[];if(!slots[0])open(0,page.querySelector('[data-mike-continue]'));else if(!slots[1])open(1,page.querySelector('[data-mike-continue]'));else root.querySelector('.buy').scrollIntoView({behavior:'smooth',block:'center'});});
    const review=document.createElement('p');review.className='mike-lock-note';review.textContent=words.locked;root.querySelector('.preview').append(review);
    loadArt(true);sync();
    const heading = root.querySelector('.dlw>h1');
    
    const intro = root.querySelector('.dlw>.lede');
    
    const title = root.querySelector('.buy h2');
    
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMike, {once:true}); else initMike();
  document.addEventListener('shopify:section:load', initMike);
})();


(() => {
 const init=()=>{
  const area=document.querySelector('.mike-photo-section');if(!area||area.dataset.ready)return;area.dataset.ready='1';
  const dialog=area.querySelector('.mike-photo-dialog'),large=area.querySelector('[data-photo-large]'),title=area.querySelector('#MikePhotoTitle');let opener,design;
  area.querySelectorAll('[data-mike-photo]').forEach(button=>button.addEventListener('click',()=>{opener=button;design=button.dataset.photoDesign;const photo=button.querySelector('img');large.src=photo.currentSrc||photo.src;large.alt=photo.alt;title.textContent=button.querySelector('span').textContent.replace('↗','').trim();dialog.showModal();}));
  area.querySelector('[data-photo-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  area.querySelector('[data-photo-choose]').addEventListener('click',()=>{dialog.close();const button=document.querySelector('[data-mike-gallery] [data-mike-design-id="'+design+'"]');if(button)button.click();else document.querySelector('#mike-designs')?.scrollIntoView({block:'start'});});
  const videos=[...document.querySelectorAll('[data-mike-films] video')];videos.forEach(v=>v.addEventListener('play',()=>videos.forEach(other=>{if(other!==v)other.pause();})));
  document.addEventListener('visibilitychange',()=>{if(document.hidden)videos.forEach(v=>v.pause());});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droplit-partner-landing"] && !Shopify.designMode) return;
  try {
    
function bindPartner(root) {
 const button=root.querySelector('[data-partner-art]');
 if(!button||button.dataset.bound)return;
 button.dataset.bound='1';
 button.addEventListener('click',()=>{
  const designer=document.querySelector('[data-partner-designer]');
  if(!designer||typeof designer.__dlAssign!=='function')return;
  const existing=designer.__dlSlots?.[0];
  if(existing&&!window.confirm(root.dataset.replacePrompt))return;
  designer.__dlAssign({preview:button.dataset.partnerArt,production:button.dataset.partnerArt,originalPreview:button.dataset.partnerArt,title:root.dataset.dlPartner,source:'library'},0);
  document.getElementById('partner-designer')?.scrollIntoView({behavior:'auto',block:'start'});
 });
}
function initPartners(){document.querySelectorAll('[data-dl-partner]').forEach(bindPartner)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPartners);else initPartners();
document.addEventListener('shopify:section:load',initPartners);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["droplit-shared-logos"] && !Shopify.designMode) return;
  try {
    
(()=>{
function brandHeaders(){
const config=document.querySelector('[data-global-branding]');if(!config)return;
const source=config.dataset.headerLogo;
function image(){const img=document.createElement('img');img.src=source;img.alt=config.dataset.alt;img.width=52;img.height=52;img.className='dl-brand-header-image';return img;}
document.querySelectorAll('.header-logo').forEach(logo=>{
if(logo.dataset.dlBranded===source)return;logo.dataset.dlBranded=source;logo.replaceChildren(image());logo.removeAttribute('data-hidden-on-home-page');
});
document.querySelectorAll('.dlc-logo,.sr-top>span:first-child').forEach(logo=>{
const prior=logo.querySelector('.dl-brand-header-link');if(prior){prior.querySelector('img').src=source;return;}
const link=document.createElement('a');link.href=config.dataset.home;link.className='dl-brand-header-link';link.setAttribute('aria-label',config.dataset.alt);link.append(image());logo.prepend(link);
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',brandHeaders,{once:true});else brandHeaders();
document.addEventListener('shopify:section:load',brandHeaders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
